import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the PWA service worker. In dev we also register so agents can test
// push notifications from the preview environment (the SW itself skips caching
// for /api/ so live API calls are never impacted).
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .catch((err) => {
        // Keep the failure case visible so admins notice a broken PWA install,
        // but drop the success log — no value in production.
        console.warn("[PWA] Service worker registration failed:", err);
      });
  });

  // When the SW forwards a notification click, route the SPA to the target URL
  // without a full reload.
  navigator.serviceWorker.addEventListener("message", (event) => {
    const data = event.data || {};
    if (data.type === "push-click" && data.url) {
      try {
        const target = new URL(data.url, window.location.origin);
        if (target.origin === window.location.origin) {
          // pushState + popstate so React Router (HashRouter/BrowserRouter) picks it up.
          window.history.pushState({}, "", target.pathname + target.search + target.hash);
          window.dispatchEvent(new PopStateEvent("popstate"));
        }
      } catch {
        /* ignore malformed URL */
      }
    }
  });
}
